/**
 * @generated SignedSource<<db5601227f9f97a24530f0a15cf4e120>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailReturnPolicy_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"useShippingAndReturns_user">;
  readonly " $fragmentType": "PdpSharedDetailReturnPolicy_user";
};
export type PdpSharedDetailReturnPolicy_user$key = {
  readonly " $data"?: PdpSharedDetailReturnPolicy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailReturnPolicy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailReturnPolicy_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShippingAndReturns_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6fa61d10d560623dcad2746f09686b3b";

export default node;
